import { WardContent } from "../../components/boundary"

export default function Ward () {
  return (
    <>
      <WardContent/>
    </>
  )
}
